module.exports = __webpack_public_path__ + "img/bloc-marque.b3b17407.svg";